import type { Feature } from './api/featuresQuery'
import { FeatureFlagMap } from './types'

export function featuresToMap(list: Feature[]) {
  const items = list.map(({ name, available }) => [name, Boolean(available)])

  return Object.fromEntries(items) as FeatureFlagMap
}
